import type { LocatorParts } from '../../Locator';
import type {
  Issue,
  OrganizationRevision,
  Project,
  Revision,
  RevisionLicense,
  RevisionScan,
} from '../../model-typings';

export type NoticeMatch = {
  id: number;
  revisionId: string;
  path: string;
  contents: string;
  copyrights?: string[];
  createdAt: Date;
  updatedAt: Date;
  corrected: boolean;
  ignored: boolean;
}

export enum NoticeMatchCorrectionType {
  Ignored = 'ignored',
  Edited = 'edited',
  Added = 'added',
  RemoveIgnored = 'remove_ignored',
  RemoveAdded = 'remove_added',
}

export type NoticeMatchCorrectionRequest = {
  correctionType: NoticeMatchCorrectionType;
  path: string;
  contents?: string;
  copyrights?: string[];
}

export type RevisionIssueScanResponse = {
  issues: Issue[];
  revisionScan: RevisionScan;
};

/**
 * The full revision endpoint (`GET /api/revisions/:locator`) returns the base
 * Revision fields plus several associations and server-computed virtual fields
 * that aren't part of the shared Revision type.
 */
export type FullRevisionResponse = Revision & {
  loc: LocatorParts;
  project: Project;
  licenses: RevisionLicense[];
  isSteady: boolean;
  meta: OrganizationRevision[];
  revisionScans: RevisionScan[];
  // eslint-disable-next-line @typescript-eslint/naming-convention -- This comes from the API
  unresolved_issue_counts: Record<string, number>;
  issues: Issue[];
};
